export class HelpConstants {
  static helpAddPropertyKey = 'RP_ADD_PROPERTY';
  static helpContactUsKey = 'RP_ONLINE_REQUEST';
  static helpBoardOfDirectorKey = 'RP_BOARD_OF_DIRECTORS';
  static helpReportViolationKey = 'RP_REPORT_DRV';
  static helpRestrictionSummaryKey = 'RP_DRV_DEFINITIONS';
  static helpAccountsPaymentKey = 'RP_PAYMENT_HISTORY';
  static helpAccountStatementKey = 'STATUS_Account Balance';
  static helpAccessMediaListKey = 'RP_ACCESS_MEDIA_LIST';
  static defaultResidentPortalKey = 'RP_DEFAULT';
  static helpRecurringPaymentKey = 'RP_ACH_CONFIGURATION';
  static helpMyDocumentsKey = 'RP_DOCUMENTS';
  static helpCommunityDashboardKey = 'RP_COMMUNITY_DASHBOARD';
  static helpCommunityInformationKey = 'RP_COMMUNITY_INFO';
  static helpCommunityLegalInformationKey = 'RP_LEGAL_INFO';
  static helpCommunityCalendarKey = 'RP_COMMUNITY_CALENDAR';
  static helpAdditionalInfoKey = 'RP_ADDITIONAL_INFO';
  static helpAccountInformationKey = 'RP_ACCOUNT_INFO';
  static helpPropertyInformationKey = 'RP_PROPERTY_INFO';
  static helpOwnerInformationKey = 'RP_OWNER_INFO';
  static helpContactInformationKey = 'RP_CONTACT_INFO';
  static helpDirectorySharingKey = 'RP_DIRECTORY_SHARING';
  static helpArchitechturalApplicationKey = 'RP_ACC';
  static helpMyDashboardKey = 'RP_DEFAULT';
  static helpAccountComplianceKey = 'RP_COMPLIANCE';
  static helpResidentDirectoryKey = 'RP_RESIDENT_DIRECTORY';
  static helpWorkOrdersKey = 'RP_WORK_ORDERS';
}
